export default __webpack_public_path__ + "static/media/gallery_02.f78f5ff3.jpg";